import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

// Downloads a blank .xlsx containing only a header row (one column per
// field name) so users have a ready-to-fill template that matches the
// exact column headers the Upload Data flow expects.
export const downloadExcelTemplate = (fields, fileName) => {
  const worksheet = XLSX.utils.aoa_to_sheet([fields]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

// Downloads a blank .xlsx template like downloadExcelTemplate, but with
// real in-cell dropdown (Data Validation > List) restrictions on some
// columns — the free `xlsx` library can't write data validation, so this
// uses `exceljs` instead, just for the columns that need it.
//
// `dropdowns` maps a column's 1-based position in `fields` to the list of
// allowed values for that column, e.g. { 1: ["Partner A", "Partner B"] }
// restricts the first column. The allowed values are written to a hidden
// lookup sheet (rather than inlined into the validation formula) since
// Excel's inline list formulae are capped at 255 characters.
export const downloadExcelTemplateWithDropdown = async (
  fields,
  fileName,
  dropdowns,
  maxRows = 500,
) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");
  sheet.addRow(fields);

  const lookupSheet = workbook.addWorksheet("Lists");
  lookupSheet.state = "veryHidden";

  Object.entries(dropdowns).forEach(([columnIndex, values], listIdx) => {
    if (!values || values.length === 0) return;

    const lookupColLetter = lookupSheet.getColumn(listIdx + 1).letter;
    values.forEach((value, i) => {
      lookupSheet.getCell(`${lookupColLetter}${i + 1}`).value = value;
    });

    const colLetter = sheet.getColumn(Number(columnIndex)).letter;
    const range = `Lists!$${lookupColLetter}$1:$${lookupColLetter}$${values.length}`;
    for (let row = 2; row <= maxRows + 1; row++) {
      sheet.getCell(`${colLetter}${row}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [range],
      };
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
};
